/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  forwardRef,
  OnInit,
  inject
} from '@angular/core';
import { Menu, MenuStyle } from 'primeng/menu';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MenuItem, OverlayService } from 'primeng/api';
import { menuDarkDt } from '../../tokens/component/menu.tokens';
import { ButtonType } from '../m-button/m-button.component.types';
import { MButtonComponent } from '../m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-menu',
  templateUrl: './m-menu.component.html',
  styleUrls: ['./m-menu.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MMenuComponent),
      multi: true
    },
    MenuStyle
  ],
  imports: [Menu, MButtonComponent]
})
export class MMenuComponent extends Menu implements OnInit {
  constructor() {
    const overlayService = inject(OverlayService);

    super(overlayService);
  }

  @Input() menuItems: MenuItem[] = [];
  @Input() override disabled: any = false;
  @Input() buttonBadge = '';
  @Input() override ariaLabel = '';
  @Input() showArrow = true;
  @Input() override id = '';
  @Input() variant: 'light' | 'dark' = 'light';
  @Input() buttonVariant: keyof typeof ButtonType = ButtonType.secondary;
  @Input() iconPlacement: 'left' | 'right' = 'right';

  public isMenuOpen = false;
  public menuDt: Record<string, any> | null = null;

  onMenuOpen(): void {
    this.isMenuOpen = true;
    this.cd.markForCheck();
  }

  onMenuClose(): void {
    this.isMenuOpen = false;
    this.cd.markForCheck();
  }

  override ngOnInit(): void {
    this.menuDt = this.variant === 'dark' ? menuDarkDt : null;
    super.ngOnInit();
  }

  // PrimeNG 20 applies root host class/style via `host: { '[class]': "cn(cx('root'), styleClass)", '[style]': "sx('root')" }`.
  // This wrapper extends Menu but renders its OWN inner <p-menu>, so that metadata is inherited onto
  // <m-menu> too — duplicating the menu root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner menu is unaffected.
  override cx(): string {
    return '';
  }

  override sx(): { [klass: string]: unknown } | undefined {
    return undefined;
  }
}
